import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RouterStateService {
    readonly currentBaseUrl: Signal<string>;

    private readonly router: Router = inject(Router);

    constructor() {
        this.currentBaseUrl = toSignal(
            this.router.events.pipe(
                filter((event): event is NavigationStart => event instanceof NavigationStart),
                map((event) => this.extractBaseUrl(event.url)),
                startWith('/dashboard')
            ),
            { initialValue: '/dashboard' }
        );
    }

    private extractBaseUrl(url: string): string {
        if (url === '/') return '/dashboard';
        const cleanUrl = url.split('?')[0].split('#')[0];
        const firstSegment = cleanUrl.split('/').filter((s) => s)[0] || 'dashboard';
        return '/' + firstSegment.split('-')[0];
    }
}
